// extracted by mini-css-extract-plugin
export default {"ScanForApp":"ScanForApp_ScanForApp__ZTE2N"};